import { grupoModel } from "./grupoModel";
export class ConcessionariaModel {
    codConcessionaria : number;
    nomeFantasia : string;
    razaoSocial : string;
    cnpj : string;
    telefone : string;
    responsavel : string;
    endereco : string;
    email : string;
    codGrupo : number;
    codMarca : number;
    codAtria : string;
    codBasico : string;
    codIntermediario : string;
    codRecomendado : string;
    codRevisoes : string;
    status : number;
    acampaatualizacao: string;
    consultor : string;
    assinatura?: string;
    temAtualizarAssinatura?:boolean;
    email_consultor: string;
    senha_consultor: string;
    cpf_consultor: string;
    cod_consultor: number;
    integracao_consultor: string;
    nome_marca: string;
    logo_marca: string;
    logo_marca_base: string;
    atualizaautomaticamente: number;
    precoosagregados: number;
    modelocardapio: number;
    dms: number;
    dmsnome: string;
    osdms: number;
    buscaplaca: number;
    tipoApp: number;
    checklist: string;
    checklistFormularios: string;
    checklistCompleto: string;
    checklistNome: string;
    documentos: DocumentosModel[];
    consultores: ConsultoresModel[];
    mecanicos: MecanicosModel[];
    mecanico: string;
    email_mecanico: string;
    cod_mecanico: number;
    nivel: number;
    modoOnline: number;
    descontoLiberado: number;
    urlintegracao: string;
    sas: sasModel;
    storageName: string;
    validade: string;
    qualidadeFoto: number;
    qualidadeVideo: number;
    desmarcaFabrica: number;
    textoLegalOrcamento: string;
    concessionariasAcesso?:Array<ConcessionariasAcesso>;
    tipoosabertura: string;
    grupo?: grupoModel;
    multiSelectApontamento: boolean;
    abrirPreOrdem: number;
    travarKmAgendamento: boolean;
    editarTempo: boolean; //serve para ativar funcao de alterar o tempo de MO na descricao do servico no cardapio.
    tipoCardapio: number;
    formatoAberturaOS: number;
    mostrarValorVeiculoOS: number;
    podeEditarValorServico: number;
    podeEditarValorPeca: number;
    podeRemoverServico: number;
    ativarRecall: boolean;
    mostrarItemNaoAutorizadoPdf: number;
    usaMCS: number;
    naoCobrarServicoAdicional: boolean;
    mostrarAssinaturaEntrega: boolean; //pdf do orcamento inicial/pre-os
    mostrarPDFGerarOS:number;
    pesquisaRecallHyundai: boolean;
    termos_uso: Date;
    appBeta:boolean = true;
    usaNovoBuscaPlaca: number;
    ativarEnvioCodigoInterno: boolean; //no vincular O.S. algumas concessionarias o codigo interno é diferente do numero OS, entao precisamos pedir.
    assinaturaUnica:boolean = true; //para a hyundai no componente de todas assinaturas, opcao de ter apenas 1 assinatura e replicar em todos os arquivos.    
    habilitaCriarChecklistPelaPreOS:boolean; // na tela de pre-os quando ativada, ao gerar, cria automaticamente um checklist no status 0 para aparecer no checklist em andamento
    podeReplicaAssinaturaChecklist:boolean; // na tela de pre-os quando ativada, ao gerar, replica a assinatura do checklist
    abrirOSPorTipo:boolean = true;
    recebeNotificacaoApp: boolean;
    timezone: string = 'America/Sao_Paulo';
    tipoOsDefault: string;
    requisitaPeca: boolean;
    checklistSimplificado: boolean; //para hyundai conseguir fazer no modo simplificado
    habilita_ia: boolean; //para habilitar os recursos de IA
    habilitaTmoOrcamento: boolean = true; //para habilitar alterar o valor total de acordo com alteracao no tempo ou qtd (e exibir tempo no pdf de pre-os)
}

export class ConcessionariasAcesso {
    codConcessionaria: number;
    nomeFantasia: string;
    logo_marca: string;
}

export class DocumentosModel {
    nome : string;
    arquivo : string;
}

export class sasModel {
    created_at : string;
    expiration : string;
    sasCode : string;
}


export class ConsultoresModel {
    nome : string;
    codigo : string;
    codIntegracao : string;
}

export class MecanicosModel {
    nome : string;
    codigo : string;
    codIntegracao : string;
}


// WEBPACK FOOTER //
// ./src/app/models/ConcessionariaModel.ts